var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoinsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 114,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noinsights_svg__clip0_1453_1113)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 14.5,
    r: 14.5,
    fill: "#FCF8E3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noinsights_svg__clip1_1453_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.002 25.027c0-.515.417-.931.931-.931h40.672c.514 0 .931.416.931.93v8.002a.931.931 0 01-.93.93H.928a.931.931 0 01-.931-.93v-8.001zM-.002 35.507c0-.514.417-.931.931-.931h40.672c.514 0 .931.416.931.93v8.002a.931.931 0 01-.93.93H.928a.931.931 0 01-.931-.93v-8.001zM-.002 45.985c0-.514.417-.93.931-.93h40.672c.514 0 .931.416.931.93v8.618a.931.931 0 01-.93.93H.928a.931.931 0 01-.931-.93v-8.618z",
    fill: "#A3C7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 25.027c0-.515.417-.931.931-.931h43.755c.514 0 .93.416.93.93v8.002a.931.931 0 01-.93.93H44.08a.931.931 0 01-.93-.93v-8.001zM43.15 35.507c0-.514.417-.93.931-.93h43.755c.514 0 .93.416.93.93v8.001a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93v-8.002zM43.15 45.986c0-.514.417-.931.931-.931h43.755c.514 0 .93.416.93.93v8.618a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93v-8.618zM89.383 25.027c0-.515.417-.931.93-.931h43.755a.93.93 0 01.931.93v8.002a.93.93 0 01-.931.93H90.314a.931.931 0 01-.931-.93v-8.001zM89.383 35.507c0-.514.417-.93.93-.93h43.755a.93.93 0 01.931.93v8.001a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93v-8.002zM89.383 45.986c0-.514.417-.931.93-.931h43.755a.93.93 0 01.931.93v8.618a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93v-8.618z",
    fill: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.002 13.931c0-.514.417-.931.931-.931h40.672c.514 0 .931.417.931.931v8.617a.931.931 0 01-.93.931H.928a.931.931 0 01-.931-.93V13.93z",
    fill: "#A3C7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 13.931c0-.514.417-.931.931-.931h43.755c.514 0 .93.417.93.931v8.617a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93V13.93zM89.383 13.931c0-.514.417-.931.93-.931h43.755a.93.93 0 01.931.931v8.617a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93V13.93z",
    fill: "#C3DEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.002 57.081c0-.514.417-.93.931-.93h40.672c.514 0 .931.416.931.93v8.001a.931.931 0 01-.93.931H.928a.931.931 0 01-.931-.93V57.08zM-.002 67.561c0-.514.417-.93.931-.93h40.672c.514 0 .931.416.931.93v8.001a.931.931 0 01-.93.931H.928a.931.931 0 01-.931-.93V67.56zM-.002 78.04c0-.514.417-.931.931-.931h40.672c.514 0 .931.417.931.93v8.618a.931.931 0 01-.93.931H.928a.931.931 0 01-.931-.93V78.04z",
    fill: "#A3C7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 57.081c0-.514.417-.93.931-.93h43.755c.514 0 .93.416.93.93v8.001a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93V57.08zM43.15 67.561c0-.514.417-.93.931-.93h43.755c.514 0 .93.416.93.93v8.001a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93V67.56zM43.15 78.04c0-.514.417-.931.931-.931h43.755c.514 0 .93.417.93.93v8.618a.931.931 0 01-.93.931H44.08a.931.931 0 01-.93-.93V78.04zM89.383 57.081c0-.514.417-.93.93-.93h43.755a.93.93 0 01.931.93v8.001a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93V57.08zM89.383 67.561c0-.514.417-.93.93-.93h43.755a.93.93 0 01.931.93v8.001a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93V67.56zM89.383 78.04c0-.514.417-.931.93-.931h43.755a.93.93 0 01.931.93v8.618a.93.93 0 01-.931.931H90.314a.931.931 0 01-.931-.93V78.04z",
    fill: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.664 95.996h92.338",
    stroke: "#F3F6F9",
    strokeWidth: 1.456,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.016,
    y: 59.07,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.016,
    y: 66.844,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.016,
    y: 74.621,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.016,
    y: 82.398,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.016,
    y: 90.172,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#noinsights_svg__filter0_d_1453_1113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 43.094,
    width: 108.861,
    height: 63.502,
    rx: 5.823,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.848 80.269l17.82-27.363 17.5 12.253 17.125 2.65 17.928 10.87 16.456 3.71",
    stroke: "#E9EEF4",
    strokeWidth: 1.456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.875 91.783l17.34-18.512 17.975-6.435 18.082 6.435 17.202 6.645 17.203 9.494",
    stroke: "#CBD5E1",
    strokeWidth: 1.456,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.73 3.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.875 87.572l17.099-14.58H126.826l21.938 8.201 17.913 5.695",
    stroke: "#68788E",
    strokeWidth: 1.456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 43.823A5.823 5.823 0 0168.823 38h97.215a5.823 5.823 0 015.823 5.823v3.897H63v-3.897z",
    fill: "#DFE5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A92E5",
    d: "M103.824 98.949h3.397v1.62h-3.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEF0FF",
    d: "M117.104 98.949h3.397v1.62h-3.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3C7F0",
    d: "M130.381 98.949h3.397v1.62h-3.397z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.457,
    y: 98.625,
    width: 7.411,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.734,
    y: 98.625,
    width: 7.411,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.014,
    y: 98.625,
    width: 7.411,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 60.68,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 52.906,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 68.453,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 76.231,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 84.008,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.184,
    y: 91.781,
    width: 5.558,
    height: 2.592,
    rx: 1.296,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.875 93.402h87.154",
    stroke: "#DFE5EC",
    strokeWidth: 1.456,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.772,
    cy: 42.492,
    r: 0.926,
    transform: "rotate(-90 161.772 42.492)",
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.551,
    cy: 42.492,
    r: 0.926,
    transform: "rotate(-90 164.551 42.492)",
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.331,
    cy: 42.492,
    r: 0.926,
    transform: "rotate(-90 167.331 42.492)",
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161 22a.999.999 0 01.993.883L162 23v1a.999.999 0 01-1.993.117L160 24v-1a.998.998 0 011-1zm-4.95-2.05a1.002 1.002 0 010 1.414l-.707.707a1 1 0 11-1.414-1.414l.707-.707a1.001 1.001 0 011.414 0zm11.314 0l.707.707a1.002 1.002 0 01-.012 1.402 1.001 1.001 0 01-1.402.012l-.707-.707a1.002 1.002 0 01.012-1.402 1.001 1.001 0 011.402-.012zM161.617 5a2 2 0 011.985 1.752l.38 3.04a5.996 5.996 0 012.816 6.75A6.002 6.002 0 01161 20.997a6.001 6.001 0 01-2.982-11.206l.38-3.04A2 2 0 01160.383 5h1.234zM161 11a3.998 3.998 0 00-2.828 6.828A3.998 3.998 0 00165 15a3.997 3.997 0 00-4-4zm-8 3a1 1 0 110 2h-1a1 1 0 110-2h1zm17 0a1 1 0 110 2h-1a1 1 0 110-2h1zm-1.929-6.07a1.002 1.002 0 010 1.414l-.707.707a1 1 0 11-1.414-1.414l.707-.707a1.001 1.001 0 011.414 0zm-12.728 0l.707.707a.998.998 0 01-.714 1.684.999.999 0 01-.7-.271l-.707-.707a.998.998 0 01.714-1.684.999.999 0 01.7.271zm6.274-.93h-1.234l-.25 2h1.734l-.25-2z",
    fill: "#FFD797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noinsights_svg__clip0_1453_1113"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h178v114H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "noinsights_svg__clip1_1453_1113"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 13)",
    d: "M0 0h135v75.414H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noinsights_svg__filter0_d_1453_1113",
    x: 57.177,
    y: 38.726,
    width: 120.508,
    height: 75.149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.456
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.912
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.521569 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1453_1113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1453_1113",
    result: "shape"
  })))));
}
export default SvgNoinsights;